__webpack_require__.p = "https://static.club.hotmart.com/admin/beta/";